import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { MainLayout } from '@/layouts/MainLayout';
import { LoginPage } from '@/pages/LoginPage';
import { CompaniesListPage } from '@/pages/CompaniesListPage';
import { CompanyCreatePage } from '@/pages/CompanyCreatePage';
import { CompanyDetailPage } from '@/pages/CompanyDetailPage';
import { TrialCompaniesPage } from '@/pages/TrialCompaniesPage';
import { ProtectedRoute } from '@/router/ProtectedRoute';

export const AppRouter: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Navigate to="/companies" replace />} />
          <Route path="/companies" element={<CompaniesListPage />} />
          <Route path="/trials" element={<TrialCompaniesPage />} />
          <Route path="/companies/new" element={<CompanyCreatePage />} />
          <Route path="/companies/:id" element={<CompanyDetailPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/companies" replace />} />
    </Routes>
  </BrowserRouter>
);
